import React, { Component } from "react";
import { getMessage } from "../Socket";
import ContentListView from "./Content";

export default class MessageList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      messageList: []
    };
  }

  componentDidMount() {
    setInterval(this.checkStoreScheduler, 100);
  }

  checkStoreScheduler = () => {
    this.setState({
      messageList: getMessage()
    });
  };

  render() {
    return <ContentListView messages={this.state.messageList} />;
  }
}



// WEBPACK FOOTER //
// ./src/chat/ContentWithWs.js